import { render, staticRenderFns } from "./thematicAreaAdvisor.vue?vue&type=template&id=391013f6"
import script from "./thematicAreaAdvisor.vue?vue&type=script&lang=js"
export * from "./thematicAreaAdvisor.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaAdvisor.vue?vue&type=style&index=0&id=391013f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports